export const DATE_AIS = new Set(['11', '12', '13', '15', '16', '17', '4326', '7006']);
export const INVALID_AI_PAIRS = [
    ['01', '02'],
    ['01', '255'],
    ['01', '8006'],
    ['22', '235'],
    ['10', '235'],
    ['21', '235'],
    ['254', '7040'],
    ['15', '17'],
    ['8017', '8018'],
];
const STATIC_DATA_ATTRIBUTES = {
    // Path qualifiers (validated via validateAttributeValue)
    '10': { min: 1, max: 20, charset: 'XCHAR' },
    '21': { min: 1, max: 20, charset: 'XCHAR' },
    '22': { min: 1, max: 20, charset: 'XCHAR' },
    '235': { min: 1, max: 28, charset: 'XCHAR' },
    '254': { min: 1, max: 20, charset: 'XCHAR' },
    '7040': { min: 4, max: 4, charset: 'XCHAR' },
    '8011': { min: 1, max: 12, charset: 'NUMERIC' },
    '8019': { min: 1, max: 10, charset: 'NUMERIC' },
    '8020': { min: 1, max: 25, charset: 'XCHAR' },
    // Query data attributes (URI Syntax v1.7.0 §4.10, pp26–33)
    '02': { min: 14, max: 14, charset: 'NUMERIC', checkDigit: true },
    '11': { min: 6, max: 6, charset: 'NUMERIC' },
    '12': { min: 6, max: 6, charset: 'NUMERIC' },
    '13': { min: 6, max: 6, charset: 'NUMERIC' },
    '15': { min: 6, max: 6, charset: 'NUMERIC' },
    '16': { min: 6, max: 6, charset: 'NUMERIC' },
    '17': { min: 6, max: 6, charset: 'NUMERIC' },
    '20': { min: 2, max: 2, charset: 'NUMERIC' },
    '30': { min: 1, max: 8, charset: 'NUMERIC' },
    '37': { min: 1, max: 8, charset: 'NUMERIC' },
    '90': { min: 1, max: 30, charset: 'XCHAR' },
    '240': { min: 1, max: 30, charset: 'XCHAR' },
    '241': { min: 1, max: 30, charset: 'XCHAR' },
    '242': { min: 1, max: 6, charset: 'NUMERIC' },
    '243': { min: 1, max: 20, charset: 'XCHAR' },
    '250': { min: 1, max: 30, charset: 'XCHAR' },
    '251': { min: 1, max: 30, charset: 'XCHAR' },
    '400': { min: 1, max: 30, charset: 'XCHAR' },
    '403': { min: 1, max: 30, charset: 'XCHAR' },
    '410': { min: 13, max: 13, charset: 'NUMERIC', checkDigit: true },
    '411': { min: 13, max: 13, charset: 'NUMERIC', checkDigit: true },
    '412': { min: 13, max: 13, charset: 'NUMERIC', checkDigit: true },
    '413': { min: 13, max: 13, charset: 'NUMERIC', checkDigit: true },
    '416': { min: 13, max: 13, charset: 'NUMERIC', checkDigit: true },
    '420': { min: 1, max: 20, charset: 'XCHAR' },
    '421': { min: 4, max: 12, charset: 'XCHAR' },
    '422': { min: 3, max: 3, charset: 'NUMERIC' },
    '423': { min: 4, max: 15, charset: 'NUMERIC' },
    '424': { min: 3, max: 3, charset: 'NUMERIC' },
    '425': { min: 4, max: 15, charset: 'NUMERIC' },
    '426': { min: 3, max: 3, charset: 'NUMERIC' },
    '427': { min: 1, max: 3, charset: 'XCHAR' },
    '4300': { min: 1, max: 35, charset: 'XCHAR' },
    '4301': { min: 1, max: 35, charset: 'XCHAR' },
    '4307': { min: 2, max: 2, charset: 'XCHAR' },
    '4308': { min: 1, max: 30, charset: 'XCHAR' },
    '4309': { min: 20, max: 20, charset: 'NUMERIC' },
    '4310': { min: 1, max: 35, charset: 'XCHAR' },
    '4311': { min: 1, max: 35, charset: 'XCHAR' },
    '4317': { min: 2, max: 2, charset: 'XCHAR' },
    '4318': { min: 1, max: 20, charset: 'XCHAR' },
    '4319': { min: 1, max: 30, charset: 'XCHAR' },
    '4320': { min: 1, max: 35, charset: 'XCHAR' },
    '4321': { min: 1, max: 1, charset: 'NUMERIC' },
    '4322': { min: 1, max: 1, charset: 'NUMERIC' },
    '4323': { min: 1, max: 1, charset: 'NUMERIC' },
    '4324': { min: 10, max: 10, charset: 'NUMERIC' },
    '4325': { min: 10, max: 10, charset: 'NUMERIC' },
    '4326': { min: 6, max: 6, charset: 'NUMERIC' },
    '7001': { min: 13, max: 13, charset: 'NUMERIC' },
    '7002': { min: 1, max: 30, charset: 'XCHAR' },
    '7003': { min: 10, max: 10, charset: 'NUMERIC' },
    '7004': { min: 1, max: 4, charset: 'NUMERIC' },
    '7005': { min: 1, max: 12, charset: 'XCHAR' },
    '7006': { min: 6, max: 6, charset: 'NUMERIC' },
    '7007': { min: 6, max: 12, charset: 'NUMERIC' },
    '7008': { min: 1, max: 3, charset: 'XCHAR' },
    '7009': { min: 1, max: 10, charset: 'XCHAR' },
    '7010': { min: 1, max: 2, charset: 'XCHAR' },
    '7011': { min: 6, max: 10, charset: 'NUMERIC' },
    '7020': { min: 1, max: 20, charset: 'XCHAR' },
    '7021': { min: 1, max: 20, charset: 'XCHAR' },
    '7022': { min: 1, max: 20, charset: 'XCHAR' },
    '7023': { min: 1, max: 30, charset: 'XCHAR' },
    '7041': { min: 1, max: 4, charset: 'XCHAR' },
    '7240': { min: 1, max: 20, charset: 'XCHAR' },
    '7241': { min: 2, max: 2, charset: 'NUMERIC' },
    '7242': { min: 1, max: 25, charset: 'XCHAR' },
    '7250': { min: 8, max: 8, charset: 'NUMERIC' },
    '7251': { min: 12, max: 12, charset: 'NUMERIC' },
    '7252': { min: 1, max: 1, charset: 'NUMERIC' },
    '7253': { min: 1, max: 40, charset: 'XCHAR' },
    '7254': { min: 1, max: 40, charset: 'XCHAR' },
    '7255': { min: 1, max: 10, charset: 'XCHAR' },
    '7256': { min: 1, max: 90, charset: 'XCHAR' },
    '7257': { min: 1, max: 70, charset: 'XCHAR' },
    '7258': { min: 3, max: 3, charset: 'XCHAR' },
    '7259': { min: 1, max: 40, charset: 'XCHAR' },
    '8001': { min: 14, max: 14, charset: 'NUMERIC' },
    '8002': { min: 1, max: 20, charset: 'XCHAR' },
    '8005': { min: 6, max: 6, charset: 'NUMERIC' },
    '8007': { min: 1, max: 34, charset: 'XCHAR' },
    '8008': { min: 8, max: 12, charset: 'NUMERIC' },
    '8009': { min: 1, max: 50, charset: 'XCHAR' },
    '8012': { min: 1, max: 20, charset: 'XCHAR' },
    '8026': { min: 18, max: 18, charset: 'NUMERIC' },
    '8030': { min: 1, max: 90, charset: 'DIGSIG' },
    '8040': { min: 15, max: 15, charset: 'NUMERIC' },
    '8041': { min: 15, max: 15, charset: 'NUMERIC' },
    '8042': { min: 32, max: 32, charset: 'NUMERIC' },
    '8043': { min: 18, max: 20, charset: 'NUMERIC' },
    '8110': { min: 1, max: 70, charset: 'XCHAR' },
    '8111': { min: 4, max: 4, charset: 'NUMERIC' },
    '8112': { min: 1, max: 70, charset: 'XCHAR' },
};
/**
 * Resolves the specification for any GS1 Data Attribute AI defined in
 * GS1 Digital Link Standard: URI Syntax v1.7.0 §4.10, pp26–33.
 */
export function getDataAttributeSpec(ai) {
    const direct = STATIC_DATA_ATTRIBUTES[ai];
    if (direct !== undefined) {
        return direct;
    }
    // 91..99: 1..90 XCHAR
    if (/^9[1-9]$/.test(ai)) {
        return { min: 1, max: 90, charset: 'XCHAR' };
    }
    // 710..717 (NHRN): 1..20 XCHAR
    if (/^71[0-7]$/.test(ai)) {
        return { min: 1, max: 20, charset: 'XCHAR' };
    }
    // 3100..3165, 3200..3295, 3300..3375, 3400..3495, 3500..3575, 3600..3695: 6DIGIT
    if (/^(31[0-6][0-5]|32[0-9][0-5]|33[0-7][0-5]|34[0-9][0-5]|35[0-7][0-5]|36[0-9][0-5])$/.test(ai)) {
        return { min: 6, max: 6, charset: 'NUMERIC' };
    }
    // 3900..3909, 3920..3929: 1..15DIGIT
    if (/^39[02][0-9]$/.test(ai)) {
        return { min: 1, max: 15, charset: 'NUMERIC' };
    }
    // 3910..3919, 3930..3939: 4..18DIGIT (3DIGIT ISO currency + 1..15DIGIT)
    if (/^39[13][0-9]$/.test(ai)) {
        return { min: 4, max: 18, charset: 'NUMERIC' };
    }
    // 3940..3943: 4DIGIT
    if (/^394[0-3]$/.test(ai)) {
        return { min: 4, max: 4, charset: 'NUMERIC' };
    }
    // 3950..3955: 6DIGIT
    if (/^395[0-5]$/.test(ai)) {
        return { min: 6, max: 6, charset: 'NUMERIC' };
    }
    // 4302..4306, 4312..4316: 1..70 XCHAR
    if (/^43[01][2-6]$/.test(ai)) {
        return { min: 1, max: 70, charset: 'XCHAR' };
    }
    // 4330..4333: 6DIGIT + optional '-'
    if (/^433[0-3]$/.test(ai)) {
        return { min: 6, max: 7, charset: 'XCHAR' };
    }
    // 7030..7039: 3DIGIT + 1..27 XCHAR
    if (/^703[0-9]$/.test(ai)) {
        return { min: 4, max: 30, charset: 'XCHAR' };
    }
    // 7230..7239: 2..30 XCHAR
    if (/^723[0-9]$/.test(ai)) {
        return { min: 2, max: 30, charset: 'XCHAR' };
    }
    return undefined;
}
/**
 * Validates GS1 Data Attributes and Path Qualifiers (length, charset, check digit, date AIs).
 * Clause: GS1 Digital Link Standard: URI Syntax v1.7.0 §4.6, p24; §4.10, pp26–33.
 */
export function validateAttributeValueWithSpec(ai, rawVal, helpers) {
    const decodedRes = helpers.decodeGs1Segment(rawVal);
    if (!decodedRes.ok) {
        return {
            ok: false,
            errorCode: 'GS1_SYNTAX_INVALID_CHARACTER_SET',
            message: `Invalid percent-encoding in AI (${ai}).`,
            clauseRef: 'GS1 Digital Link Standard: URI Syntax v1.7.0 §4.2, pp21–22',
        };
    }
    const val = decodedRes.value;
    if (DATE_AIS.has(ai)) {
        if (!helpers.isValidGs1DateAi(val)) {
            return {
                ok: false,
                errorCode: 'GS1_SYNTAX_INVALID_DATE_AI',
                message: `Date AI (${ai}) value '${val}' is not a valid YYMMDD date.`,
                clauseRef: 'GS1 General Specifications Release 26.0 §3.4.7',
            };
        }
        return { ok: true, decoded: val };
    }
    const spec = getDataAttributeSpec(ai);
    if (spec === undefined) {
        return { ok: true, decoded: val };
    }
    if (val.length < spec.min || val.length > spec.max) {
        return {
            ok: false,
            errorCode: 'GS1_SYNTAX_INVALID_KEY_LENGTH',
            message: `AI (${ai}) length must be between ${String(spec.min)} and ${String(spec.max)}.`,
            clauseRef: 'GS1 Digital Link Standard: URI Syntax v1.7.0 §4.6, p24; §4.10, pp26–33',
        };
    }
    if (ai === '8011' && val.startsWith('0')) {
        return {
            ok: false,
            errorCode: 'GS1_SYNTAX_INVALID_KEY_LENGTH',
            message: 'CPID Serial (8011) must not have leading zeros.',
            clauseRef: 'GS1 Digital Link Standard: URI Syntax v1.7.0 §4.6, p24',
        };
    }
    if (ai === '7040' && !/^[0-9]/.test(val)) {
        return {
            ok: false,
            errorCode: 'GS1_SYNTAX_INVALID_CHARACTER_SET',
            message: 'UIC with Extension 1 (7040) must start with 1 numeric digit followed by 3 XCHARs.',
            clauseRef: 'GS1 Digital Link Standard: URI Syntax v1.7.0 §4.6, p24',
        };
    }
    if (!helpers.isValidCharset(val, spec.charset)) {
        return {
            ok: false,
            errorCode: 'GS1_SYNTAX_INVALID_CHARACTER_SET',
            message: `AI (${ai}) contains characters outside allowed ${spec.charset} set.`,
            clauseRef: 'GS1 General Specifications Release 26.0 Table 7-20, p551',
        };
    }
    if (spec.checkDigit === true && !helpers.verifyCheckDigit(val)) {
        return {
            ok: false,
            errorCode: 'GS1_SYNTAX_INVALID_CHECK_DIGIT',
            message: `AI (${ai}) failed mod-10 check digit verification.`,
            clauseRef: 'GS1 General Specifications Release 26.0 §7.9',
        };
    }
    return { ok: true, decoded: val };
}
/**
 * Validates mutually exclusive AI pairs (Table 4-4) and mandatory AI associations (Table 4-5).
 * Clause: GS1 General Specifications Release 26.0 §4.13.1–§4.13.2, pp294–303.
 */
export function validatePairsAndAssociations(allAis, pathQualifiers) {
    for (const [ai1, ai2] of INVALID_AI_PAIRS) {
        if (allAis.has(ai1) && allAis.has(ai2)) {
            return {
                ok: false,
                errorCode: 'GS1_SYNTAX_INVALID_AI_PAIR',
                message: `AI (${ai1}) and AI (${ai2}) cannot be combined in the same GS1 Digital Link URI.`,
                clauseRef: 'GS1 General Specifications Release 26.0 §4.13.1, Table 4-4, p294–296',
            };
        }
    }
    if (allAis.has('415') && pathQualifiers['8020'] === undefined) {
        return {
            ok: false,
            errorCode: 'GS1_SYNTAX_MISSING_MANDATORY_ASSOCIATION',
            message: 'Pay-To GLN (415) requires mandatory Payment Slip Reference (8020) in the URI path.',
            clauseRef: 'GS1 Digital Link Standard: URI Syntax v1.7.0 §4.9, p25; GS1 General Specifications Release 26.0 §4.13.2, Table 4-5, p297–298',
        };
    }
    for (const depAi of ['10', '11', '13', '15', '16']) {
        if (allAis.has(depAi) && !allAis.has('01') && !allAis.has('02') && !allAis.has('8006')) {
            return {
                ok: false,
                errorCode: 'GS1_SYNTAX_MISSING_MANDATORY_ASSOCIATION',
                message: `AI (${depAi}) requires primary key (01), (02), or (8006).`,
                clauseRef: 'GS1 General Specifications Release 26.0 §4.13.2, Table 4-5, p297–298',
            };
        }
    }
    if (allAis.has('17') &&
        !allAis.has('01') &&
        !allAis.has('02') &&
        !allAis.has('8006') &&
        !allAis.has('255')) {
        return {
            ok: false,
            errorCode: 'GS1_SYNTAX_MISSING_MANDATORY_ASSOCIATION',
            message: 'Expiration Date (17) requires (01), (02), (8006), or (255).',
            clauseRef: 'GS1 General Specifications Release 26.0 §4.13.2, Table 4-5, p297–298',
        };
    }
    if (allAis.has('8030')) {
        const validDigSigCombo = (allAis.has('01') && allAis.has('21')) ||
            (allAis.has('8006') && allAis.has('21')) ||
            (allAis.has('8010') && allAis.has('8011')) ||
            allAis.has('8003');
        if (!validDigSigCombo) {
            return {
                ok: false,
                errorCode: 'GS1_SYNTAX_MISSING_MANDATORY_ASSOCIATION',
                message: 'Digital Signature (8030) requires (01+21), (8006+21), (8010+8011), or (8003).',
                clauseRef: 'GS1 General Specifications Release 26.0 §4.13.2, Table 4-5, p303',
            };
        }
    }
    return { ok: true };
}
//# sourceMappingURL=attribute-specs.js.map